// This file is automatically updated during the build process
export const VERSION = {
  buildTime: new Date().toISOString(),
  commitHash: import.meta.env.VITE_COMMIT_HASH || 'development',
  buildNumber: import.meta.env.VITE_BUILD_NUMBER || 'local'
};
